/**
 * Resolves the user's language for API `lang` params: the user's chosen locale,
 * then the browser language, then an English floor.
 *
 * Deliberately excludes the building locale. `lang` is a translating signal and
 * must follow the user, not the building's admin locale — routing it through the
 * building locale (or the 12-entry `LocaleEnum` gate in `handleNonISOLocales`) is
 * what makes an en-us user at a Dutch building receive Dutch confirmations.
 */
export const getUserLocale = (configLocale?: string | null): string => configLocale || navigator?.language || 'en-us';
